import { compact, join } from 'lodash-es';

interface Address {
  addressLine1?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  region?: string;
}

export function formatAddress(address?: Address): string {
  if (!address) return '-';

  return join(
    compact([
      address.addressLine1,
      address.city,
      address.region,
      address.postalCode,
      address.country,
    ]),
    ', ',
  );
}

export function formatFullName(name?: {
  firstName?: string;
  lastName?: string;
}): string {
  if (!name) return '-';
  return join(compact([name.firstName, name.lastName]), ' ');
}
